function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M255.1 70.6h-21.3v-7c0-15.6-12.7-28.3-28.3-28.3H78c-15.6 0-28.3 12.7-28.3 28.3v7H28.3C12.7 70.6 0 83.3 0 99v127.6c0 15.6 12.7 28.3 28.3 28.3h226.8c15.6 0 28.3-12.7 28.3-28.3V99c0-15.7-12.6-28.4-28.3-28.4zm0 155.9H28.3V99H78V63.7h127.6V99h49.6l-.1 127.5zM141.7 120.9c17.5 0 31.6 14.2 31.6 31.6s-14.2 31.6-31.6 31.6-31.6-14.2-31.6-31.6c0-17.5 14.2-31.6 31.6-31.6m0-28.5c-33.2 0-60.1 26.9-60.1 60.1s26.9 60.1 60.1 60.1 60.1-26.9 60.1-60.1-26.9-60.1-60.1-60.1z"
})));